import { render, staticRenderFns } from "./businessInvoice.vue?vue&type=template&id=20b3c772&scoped=true"
import script from "./businessInvoice.vue?vue&type=script&lang=js"
export * from "./businessInvoice.vue?vue&type=script&lang=js"
import style0 from "./businessInvoice.vue?vue&type=style&index=0&id=20b3c772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3c772",
  null
  
)

export default component.exports